import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { RoomBooking, RoomBookingServiceBooking, Service } from '../../models';
import { ApiService } from '../../utils/api.service';

@Injectable()
export class RoomBookingServiceBookingService {

  path = 'room_booking_service_bookings';

  constructor(
    private api: ApiService,
  ) {
  }

  create(booking): Observable<RoomBookingServiceBooking> {
    return this.api.post(this.path, booking);
  }

  createForRoomBooking(
    serviceBookings: RoomBookingServiceBooking[],
    roomBooking: RoomBooking,
  ): Observable<RoomBookingServiceBooking[]> {
    serviceBookings.map(serviceBooking => {
      if (typeof serviceBooking.service === 'string') {
        serviceBooking.service = new Service({id: +serviceBooking.service.split('/').pop()});
      }
      return serviceBooking;

    });

    return this.api.post(`room_bookings/${roomBooking.id}/service_bookings`, serviceBookings)
      .pipe(
        map(data => data.map((serviceBooking => new RoomBookingServiceBooking(serviceBooking)))),
      );
  }
}
